import { useEffect } from 'react'
import { Outlet } from 'react-router'
import demoStyles from '#app/styles/demo-site.css?url'
import { type Route } from './+types/_layout.ts'
import { DemoFooter } from './+components/footer.tsx'
import { DemoHeader } from './+components/header.tsx'

export const links: Route.LinksFunction = () => [
	{
		rel: 'preconnect',
		href: 'https://fonts.googleapis.com',
	},
	{
		rel: 'preconnect',
		href: 'https://fonts.gstatic.com',
		crossOrigin: 'anonymous',
	},
	{
		rel: 'stylesheet',
		href: 'https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap',
	},
	{ rel: 'stylesheet', href: demoStyles },
]

function useReveal() {
	useEffect(() => {
		const els = document.querySelectorAll('.ds-reveal')
		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((e) => {
					if (e.isIntersecting) {
						e.target.classList.add('in')
						io.unobserve(e.target)
					}
				})
			},
			{ threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
		)
		els.forEach((el) => io.observe(el))
		return () => io.disconnect()
	})
}

export default function MarketingLayout() {
	useReveal()

	return (
		<div className="demo-site">
			<DemoHeader />
			<main>
				<Outlet />
			</main>
			<DemoFooter />
			<MobileCTA />
		</div>
	)
}

function MobileCTA() {
	useEffect(() => {
		const el = document.getElementById('ds-mobile-cta')
		if (!el) return
		const fn = () => {
			if (window.scrollY > 560) {
				el.classList.remove('translate-y-full')
				el.classList.add('translate-y-0')
			} else {
				el.classList.remove('translate-y-0')
				el.classList.add('translate-y-full')
			}
		}
		fn()
		window.addEventListener('scroll', fn, { passive: true })
		return () => window.removeEventListener('scroll', fn)
	}, [])

	return (
		<div
			id="ds-mobile-cta"
			className="ds-mcta fixed inset-x-0 bottom-0 z-40 translate-y-full border-t border-[#1c1917]/10 transition-transform duration-300 md:hidden"
			style={{ background: '#f5f1ea' }}
		>
			<div className="flex items-stretch">
				<a
					href="tel:+18175550199"
					className="flex flex-1 items-center justify-center gap-2 border-r border-[#1c1917]/10 py-4 text-[14px] font-semibold"
					style={{ color: '#1c1917' }}
				>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
						<path
							d="M2 2.5C2 2 2.5 1.5 3 1.5H4.5C4.8 1.5 5 1.7 5 2L5.5 4C5.5 4.3 5.3 4.5 5 4.7L4 5.3C4.6 6.7 7.3 9.4 8.7 10L9.3 9C9.5 8.7 9.7 8.5 10 8.5L12 9C12.3 9 12.5 9.2 12.5 9.5V11C12.5 11.5 12 12 11.5 12C6 12 2 8 2 2.5Z"
							stroke="currentColor"
							strokeWidth="1.4"
						/>
					</svg>
					Call now
				</a>
				<a
					href="#estimate"
					className="ds-btn-primary flex flex-[1.3] items-center justify-center gap-2 rounded-none py-4 text-[14px] font-semibold"
				>
					Free estimate
					<svg width="12" height="10" viewBox="0 0 14 10" fill="none">
						<path
							d="M1 5H13 M9 1L13 5L9 9"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</a>
			</div>
		</div>
	)
}
